export default function cleanConversationFilters(filters, defaults) {
    return Object.fromEntries(
        Object.entries(filters).filter(([key, value]) =>
            value !== "" && value !== null &&
            !(Array.isArray(value) && value.length === 0) &&
            !(key === "score_min" && value === defaults.score_min) &&
            !(key === "score_max" && value === defaults.score_max)
        )
    );
}
